const traccarPurple = '#333366';
const traccarGreen = '#4CAF50';
const traccarWhite = '#FFF';

export default {
  common: {
    purple: traccarPurple,
    green: traccarGreen
  },
  primary: {
    main: traccarPurple
  },
  secondary: {
    main: traccarGreen,
    contrastText: traccarWhite
  }
};
